import * as actionTypes from '../actions/actionTypes'
import Moment from 'moment'

const condominiumInitialState = {
  id: 2,
  name: 'INOVT',
  short_name: 'INOVT'
}
export const condominiumReducer = (state = condominiumInitialState, {type, payload}) => {
  switch (type) {
    case actionTypes.LOAD_CONDOMINIUM_SUCCESS:
      return {
        ...state,
        ...payload.condominium
      }
    default:
      return state
  }
}

const buildingReducer = (state, {type, payload}) => {
  switch (type) {
    case actionTypes.LOAD_TANKS_SUCCESS:
      if (state.id !== payload.buildingId) {
        return state
      }
      return {
        ...state,
        tanks: payload.tanks
      }
    default:
      return state
  }
}
export const buildingsReducer = (state = [], {type, payload}) => {
  switch (type) {
    case actionTypes.LOAD_BUILDINGS_SUCCESS:
      return [
        ...state,
        ...payload.buildings
      ]
    case actionTypes.LOAD_TANKS_SUCCESS:
      return state.map(building => buildingReducer(building, {type, payload}))
    default:
      return state
  }
}

const cisternReducer = (state, {type, payload}) => {
  switch (type) {
    case actionTypes.LOAD_BOMBS_SUCCESS:
      if (state.id !== payload.cisternId) {
        return state
      }
      return {
        ...state,
        bombs: payload.bombs
      }
    default:
      return state
  }
}
export const cisternsReducer = (state = [], {type, payload}) => {
  switch (type) {
    case actionTypes.LOAD_CISTERNS_SUCCESS:
      return [
        ...state,
        ...payload.cisterns
      ]
    case actionTypes.LOAD_BOMBS_SUCCESS:
      return state.map(cistern => cisternReducer(cistern, {type, payload}))
    default:
      return state
  }
}

const hubReducer = (state, {type, payload}) => {
  switch (type) {
    case actionTypes.LOAD_HUB_STATUS_SUCCESS:
      if (state.id !== payload.hubStatus.hub) {
        return state
      }
      return {
        ...state,
        status: payload.hubStatus.status,
        status_update_at: payload.hubStatus.created_at
      }
    case actionTypes.MQTT_NEW_MESSAGE:
      if (state.alias !== payload.topicValues[1] && state.mqtt_user !== payload.topicValues[1]) {
        return state
      }
      if ((Number(payload.messageValues[0]) === 1) === state.status) {
        return state
      }
      return {
        ...state,
        status: Number(payload.messageValues[0]) === 1,
        status_update_at: Moment().toISOString()
      }
    default:
      return state
  }
}
export const hubsReducer = (state = [], {type, payload}) => {
  switch (type) {
    case actionTypes.LOAD_HUBS_SUCCESS:
      return [
        ...state,
        ...payload.hubs
      ]
    case actionTypes.LOAD_HUB_STATUS_SUCCESS:
      return state.map(hub => hubReducer(hub, {type, payload}))
    case actionTypes.MQTT_NEW_MESSAGE:
      if (payload.topicValues.length !== 2) {
        return state
      }
      return state.map(hub => hubReducer(hub, {type, payload}))
    default:
      return state
  }
}

export const modulesReducer = (state = [], {type, payload}) => {
  switch (type) {
    case actionTypes.LOAD_MODULES_SUCCESS:
      return [
        ...state,
        ...payload.modules
      ]
    default:
      return state
  }
}

const notificationReducer = (state, {type, payload}) => {
  switch (type) {
    case actionTypes.LAUNCH_NOTIFICATION:
      if (state.id !== payload.notificationId) {
        return state
      }
      return {
        ...state,
        launch_at: Moment().toISOString(),
        clicked_at: undefined
      }
    case actionTypes.CLICK_NOTIFICATION:
      if (state.id !== payload.notificationId) {
        return state
      }
      return {
        ...state,
        clicked_at: Moment().toISOString()
      }
    case actionTypes.LOGOUT:
      return {
        ...state,
        launch_at: undefined,
        clicked_at: undefined
      }
    default:
      return state
  }
}
export const notificationsReducer = (state = [], {type, payload}) => {
  switch (type) {
    case actionTypes.LOAD_NOTIFICATIONS_SUCCESS:
      return [
        ...state,
        ...payload.notifications
      ]
    case actionTypes.LOGOUT:
    case actionTypes.CLICK_NOTIFICATION:
    case actionTypes.LAUNCH_NOTIFICATION:
      return state.map(notification => notificationReducer(notification, {type, payload}))
    default:
      return state
  }
}

const INFORMATION_BINARY_MODE = [5, 6]
const informationReducer = (state, {type, payload}) => {
  switch (type) {
    case actionTypes.LOAD_INFORMATION_UPDATES_SUCCESS:
      if (state.id !== payload.informationId) {
        return state
      }
      return {
        ...state,
        updates: payload.updates
      }
    case actionTypes.MQTT_NEW_MESSAGE:
      if (state.information_type !== Number(payload.topicValues[3]) ||
        state.module_identifier !== Number(payload.topicValues[2]) ||
        state.identifier !== Number(payload.messageValues[0]) ||
        state.hub_identifier !== payload.topicValues[1]) {
        return state
      }
      if (state.updates.length > 0 && Math.abs(state.updates[0].data - Number(payload.messageValues[1])) <= 0.5) {
        return state
      }
      return {
        ...state,
        updates: [
          {
            data: Number(payload.messageValues[1]),
            created_at: Moment().toISOString()
          },
          ...state.updates.slice(0, 4)
        ]
      }
    default:
      return state
  }
}
export const informationsReducer = (state = [], {type, payload}) => {
  switch (type) {
    case actionTypes.LOAD_INFORMATIONS_SUCCESS:
      return [
        ...state,
        ...payload.informations
      ]
    case actionTypes.LOAD_INFORMATION_UPDATES_SUCCESS:
      return state.map(information => informationReducer(information, {type, payload}))
    case actionTypes.MQTT_NEW_MESSAGE:
      if (payload.topicValues.length !== 4) {
        return state
      }
      if (INFORMATION_BINARY_MODE.indexOf(Number(payload.topicValues[3])) > -1) {
        let newState = [...state]
        for (let i = 0; i < 8; i++) {
          let innerPayload = {...payload}
          let messageValues = []
          messageValues[0] = `${payload.messageValues[0]}${i + 1}`
          messageValues[1] = (Number(payload.messageValues[1]) & (1 << i)) !== 0 ? '1' : '0'
          innerPayload.messageValues = messageValues
          newState = newState.map(information => informationReducer(information, {type, payload: innerPayload}))
        }
        return newState
      }
      return state.map(information => informationReducer(information, {type, payload}))
    default:
      return state
  }
}

const commandReducer = (state, {type, payload}) => {
  switch (type) {
    case actionTypes.LOAD_COMMAND_LOGS_SUCCESS:
      if (state.id !== payload.commandId) {
        return state
      }
      return {
        ...state,
        logs: payload.logs
      }
    case actionTypes.MQTT_NEW_MESSAGE:
      if (state.identifier !== Number(payload.messageValues[0]) ||
        state.module_identifier !== Number(payload.topicValues[2]) ||
        state.hub_identifier !== payload.topicValues[1]) {
        return state
      }
      return {
        ...state,
        logs: [
          {
            data: Number(payload.messageValues[1]),
            created_at: Moment().toISOString()
          },
          ...state.logs.slice(0, 4)
        ]
      }
    default:
      return state
  }
}
export const commandsReducer = (state = [], {type, payload}) => {
  switch (type) {
    case actionTypes.LOAD_COMMANDS_SUCCESS:
      return [
        ...state,
        ...payload.commands
      ]
    case actionTypes.LOAD_COMMAND_LOGS_SUCCESS:
      return state.map(command => commandReducer(command, {type, payload}))
    case actionTypes.MQTT_NEW_MESSAGE:
      if (payload.topicValues.length !== 3) {
        return state
      }
      return state.map(command => commandReducer(command, {type, payload}))
    default:
      return state
  }
}

const dashboardInitialState = {
  isLoadStarted: false,
  isLoading: 0,
  mqttClient: null,
  timeoutId: null
}
export const dashboardReducer = (state = dashboardInitialState, {type, payload}) => {
  switch (type) {
    case actionTypes.LOAD_STARTED:
      return Object.assign({}, state, {
        isLoadStarted: true
      })
    case actionTypes.MQTT_NEW_CLIENT:
      return Object.assign({}, state, {
        mqttClient: payload.client
      })
    case actionTypes.HANDLE_NOTIFICATIONS:
      return Object.assign({}, state, {
        notificationTimeoutId: payload.timeoutId
      })
    case actionTypes.LOAD_CONDOMINIUM_LOADING:
    case actionTypes.LOAD_BUILDINGS_LOADING:
    case actionTypes.LOAD_CISTERNS_LOADING:
    case actionTypes.LOAD_HUBS_LOADING:
    case actionTypes.LOAD_HUB_STATUS_LOADING:
    case actionTypes.LOAD_MODULES_LOADING:
    case actionTypes.LOAD_INFORMATIONS_LOADING:
    case actionTypes.LOAD_INFORMATION_UPDATES_LOADING:
    case actionTypes.LOAD_COMMANDS_LOADING:
    case actionTypes.LOAD_COMMAND_LOGS_LOADING:
    case actionTypes.LOAD_TANKS_LOADING:
    case actionTypes.LOAD_BOMBS_LOADING:
    case actionTypes.LOAD_BOMB_MODELS_LOADING:
    case actionTypes.LOAD_MANUFACTURERS_LOADING:
    case actionTypes.LOAD_NOTIFICATIONS_LOADING:
      return Object.assign({}, state, {
        isLoading: payload.loading ? state.isLoading + 1 : state.isLoading - 1
      })
    case actionTypes.LOAD_CONDOMINIUM_ERROR:
    case actionTypes.LOAD_BUILDINGS_ERROR:
    case actionTypes.LOAD_CISTERNS_ERROR:
    case actionTypes.LOAD_HUBS_ERROR:
    case actionTypes.LOAD_HUB_STATUS_ERROR:
    case actionTypes.LOAD_MODULES_ERROR:
    case actionTypes.LOAD_INFORMATIONS_ERROR:
    case actionTypes.LOAD_INFORMATION_UPDATES_ERROR:
    case actionTypes.LOAD_COMMANDS_ERROR:
    case actionTypes.LOAD_COMMAND_LOGS_ERROR:
    case actionTypes.LOAD_TANKS_ERROR:
    case actionTypes.LOAD_BOMBS_ERROR:
    case actionTypes.LOAD_BOMB_MODELS_ERROR:
    case actionTypes.LOAD_MANUFACTURERS_ERROR:
    case actionTypes.LOAD_NOTIFICATIONS_ERROR:
      return Object.assign({}, state, {
        isLoading: state.isLoading - 1
      })
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/dashboardReducers.js
 **/